import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import Table from 'react-bootstrap/Table';
import AccuracyBadgeWithTooltip from "../../accuracy-badge-with-tooltip";
import { TOOL_ACCURACY, TOOL_ACCURACY_INCREASE, TOOL_ACCURACY_TOOLTIP } from "../../../helpers/accuracy";

const StyledContainer = styled(Container)`
  .table-responsive {
    overflow-x: auto;
  }
  .table {
    margin-bottom: 1rem;
  }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
  }
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
  }
  .table tbody + tbody {
    border-top: 2px solid #dee2e6;
  }
  .table-striped > tbody > tr:nth-of-type(odd) > * {
    --bs-table-accent-bg:#d0dfeb !important;
    color: var(--bs-table-striped-color);
    border-color: #9daac7 !important;
}
.table-shadow {
     box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
     border-radius:10px;
  }
  a {
    color: #ffa700!important;
  }
  a:hover {
    color: gray!important;
  }
  @media(max-width: 574px) {
    .table-responsive {
      width: 100%;
    }
  }

`

const CovsOthers = () => {
    return (
        <StyledContainer>
            <div className="text-center pb-4">
                <h2>Comparison with Top Email Verification Tools</h2>
                <p>Read <a href="/list-of-email-verification-services-tools-compared/">here</a> to know more about 50+ email verification tools with their USP</p>
            </div>
            <div className="table-responsive">
                <Table striped bordered hover className="table">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="fw-bolder">Clearout</th>
                            <th className="fw-bolder">Zerobounce</th>
                            <th className="fw-bolder">Neverbounce</th>
                            <th className="fw-bolder">Xverify</th>
                            <th className="fw-bolder">Hunter</th>
                            <th className="fw-bolder">Kickbox</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="fw-bolder">Price per 1,000 Verifications</td>
                            <td className="fw-bolder">$5</td>
                            <td>$10</td>
                            <td>$8</td>
                            <td>$10</td>
                            <td>$49/month</td>
                            <td>$10</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Free Credits</td>
                            <td className="fw-bolder">100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Minimum Purchasable Credits</td>
                            <td className="fw-bolder">3000</td>
                            <td>2000</td>
                            <td>1000</td>
                            <td>500</td>
                            <td>1000</td>
                            <td>500</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Accuracy</td>
                            <td className="fw-bolder"><AccuracyBadgeWithTooltip
              accuracy={TOOL_ACCURACY}
              increase={TOOL_ACCURACY_INCREASE}
              tooltipText={TOOL_ACCURACY_TOOLTIP}
            /></td>
                            <td>98%+</td>
                            <td>Unknown</td>
                            <td>97%</td>
                            <td>Unknown</td>
                            <td>Unknown</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">De-duplication Charges</td>
                            <td className="fw-bolder">Free</td>
                            <td>Free</td>
                            <td>Free</td>
                            <td>Chargeable</td>
                            <td>Chargeable</td>
                            <td>Chargeable</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Upload File Formats</td>
                            <td className="fw-bolder">CSV, XLSX</td>
                            <td>TXT, CSV</td>
                            <td>CSV</td>
                            <td>CSV</td>
                            <td>CSV</td>
                            <td>CSV, XLSX, XLS, ODS</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Yahoo/AOL Support</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Customer Support</td>
                            <td className="fw-bolder">24/7</td>
                            <td>24/7</td>
                            <td>Business Hours</td>
                            <td>Business Hours</td>
                            <td>Business Hours</td>
                            <td>Business Hours</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Checking DNSBLs & URI DNSBLs</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>Yes</td>
                            <td>Unknown</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">On-boarding without Card</td>
                            <td className="fw-bolder">Available</td>
                            <td>Available</td>
                            <td>Available</td>
                            <td>N/A</td>
                            <td>Available</td>
                            <td>Available</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Chat Support</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Auto Suggestion</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Email/Domain Allowlisting</td>
                            <td className="fw-bolder">Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Email/Domain Blocklisting</td>
                            <td className="fw-bolder">Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Anti Greylisting</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Gibberish Check</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Unknown</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Integrates with Apollo.io</td>
                            <td className="fw-bolder">Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">WordPress Plugin for Email Verification</td>
                            <td className="fw-bolder">Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">WooCommerce Email Verification Support</td>
                            <td className="fw-bolder">Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">JavaScript Widget</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Verification Period</td>
                            <td className="fw-bolder">Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Verification Timestamp</td>
                            <td className="fw-bolder">Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Disposable Account Verification</td>
                            <td className="fw-bolder">Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>Yes</td>
                        </tr>
                    </tbody>
                </Table>
                <span className="fs-6"><b>Disclaimer:</b> The third party's name is utilized for comparison purposes only and is the trademark of its respective owner. Clearout claims no rights whatsoever in the use of such name and/or any related trademarks. Clearout is not affiliated with the third party referenced on this page.</span>
            </div>
        </StyledContainer>
    )
}

export default CovsOthers;